import {FileConfiguration} from '../../file/message/FileConfiguration';
import {PredefinedBaseConfiguration} from './PredefinedBaseConfiguration';

export class MoveBucketFileConfiguration extends PredefinedBaseConfiguration {
createWitnessFile: boolean | null;
destinationFile: FileConfiguration;
exitStatusOnMovedFile: boolean | null;
exitStatusOnNoMovedFile: boolean | null;
originFile: FileConfiguration;
}

